module.exports = __webpack_public_path__ + "img/friend19.1b394f72.png";